export default "__VITE_ASSET__hukpAjOk__"